import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Video, Phone, Mic, MicOff } from "lucide-react";
import { toast } from "@/components/ui/use-toast";

interface CallControlsProps {
  onStartVideoCall: () => void;
  onStartVoiceCall: () => void;
  isInCall: boolean;
}

export const CallControls = ({ onStartVideoCall, onStartVoiceCall, isInCall }: CallControlsProps) => {
  const [isMuted, setIsMuted] = useState(false);

  const handleMuteToggle = () => {
    setIsMuted(!isMuted);
    toast({
      title: isMuted ? "Microphone unmuted" : "Microphone muted",
      duration: 2000,
    });
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="icon"
        onClick={onStartVideoCall}
        disabled={isInCall}
        className="hover:bg-primary/20"
      >
        <Video className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="icon"
        onClick={onStartVoiceCall}
        disabled={isInCall}
        className="hover:bg-primary/20"
      >
        <Phone className="h-4 w-4" />
      </Button>
      {isInCall && (
        <Button
          variant={isMuted ? "destructive" : "outline"}
          size="icon"
          onClick={handleMuteToggle}
          className="hover:bg-primary/20"
        >
          {isMuted ? (
            <MicOff className="h-4 w-4" />
          ) : (
            <Mic className="h-4 w-4" />
          )}
        </Button>
      )}
    </div>
  );
};